<template>
  <div class="History__body">
    <div class="History__body-container">
      <div class="History__title">
        History
      </div>

      <div v-if="history.length"
           class="History__list">
        <div v-for="(group, key) in history.groups">
          <span class="History__group-name">
            {{ key }}
          </span>
          <div class="History__row" v-for="event in group">
            <div class="History__row-info">
              <div class="History__row-date">
                {{ event.startTimeInMillis | moment("DD")}}
              </div>
              <div class="History__conference-info">
                <div class="History__conference-title">
                  {{ event.title || 'Untitled' }}
                </div>
                <div class="History__conference-started">
                  {{ event.startTimeInMillis | moment("dddd, MMMM Do [at] h:mm a")}}
                </div>
                <div class="History__conference-duration">
                  {{ event.duration }}
                </div>
              </div>
            </div>
            <transition-group
            name="fade-in"
            tag="div"
            class="History__row-attendees">
              <span class="History__row-attendees-title"
                    key="title">
                {{ event.attendeesUserIds.length }} Attendees:
              </span>
              <div v-for="(attendant, key) in event.attendees"
                   :key="key"
                   class="History__attendant">
                {{ attendant }}</div>
            </transition-group>
          </div>
        </div>
        <infinite-loading
        class="History__infinite-loading-container"
        direction="bottom"
        spinner="circles"
        @infinite="getHistory"
        ref="historyLoading">
          <span slot="no-more"></span>
          <div slot="spinner">
            <i class="icon-ic_spinner History__loading"></i>
          </div>
        </infinite-loading>
      </div>

      <div v-if="!history.length && !initializing"
           class="History__empty-results">
        <img class="History__empty-results-img"
             src="../../../../static/images/history_empty.png"/>
        <div class="History__empty-results-text">
          You haven’t held any meetings.
        </div>
      </div>

      <i v-if="initializing" class="icon-ic_spinner History__loading"></i>
    </div>
    <page-title title="KingsConference - History"></page-title>
  </div>
</template>

<script>
  import api from '@/api';
  import PageTitle from '@/components/common/page-title/page-title';

  export default {
    name: 'history-tab',
    components: {
      PageTitle
    },
    data() {
      return {
        initializing: false
      };
    },
    computed: {
      user() {
        return this.$store.getters.currentUser;
      },
      history() {
        return this.$store.getters.userHistory;
      },
      userInfo() {
        return this.$store.getters.usersInfo;
      }
    },
    methods: {
      getHistory($state) {
        this.$store.dispatch('getUserHistory').then(endOfList => {
          this.initializing = false;
          if ($state) {
            if (endOfList) {
              $state.complete();
            } else {
              $state.loaded();
            }
          }
        });
      }
    },
    mounted() {
      this.initializing = true;
      this.getHistory();
    },
    destroyed() {
      this.$store.commit('clearHistoryState');
    }
  };
</script>

<style scoped lang="scss">
  @import 'style.scss';
</style>



// WEBPACK FOOTER //
// history-tab.vue?28d8c76d